var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { env } from '../environment';
import style from '../css/breadcrumb_css';
let Breadcrumb = class Breadcrumb extends LitElement {
    constructor() {
        super(...arguments);
        this.type = 'full';
    }
    static get styles() {
        if (env.debug) {
            return css ``;
        }
        return [style];
    }
    firstUpdated() {
        const gs1BreadcrumbsContainer = this.shadowRoot.querySelector('.breadcrumb');
        const childArray = Array.from(this.children);
        childArray.forEach((item, i) => {
            if (!item.hasAttribute('slot')) {
                if (item.tagName == 'LI') {
                    item.classList.add('breadcrumb-item');
                    if (Object.is(childArray.length - 1, i) && this.type != 'narrow') {
                        item.classList.add('active');
                    }
                }
                gs1BreadcrumbsContainer.appendChild(item);
            }
        });
    }
    render() {
        return html ` ${env.debug
            ? html `<link rel="stylesheet" href="/css/breadcrumb.css" />`
            : html ``}
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb ${this.type}"></ol>
      </nav>`;
    }
};
__decorate([
    property()
], Breadcrumb.prototype, "type", void 0);
Breadcrumb = __decorate([
    customElement('gs1-breadcrumb')
], Breadcrumb);
export { Breadcrumb };
//# sourceMappingURL=breadcrumb.js.map